import { read } from '@/api/rest';

const performerPage = {
  executorWithTasks: async (projectId) =>
    await read('/performer-page/executor-with-tasks?projectId=' + projectId),
  checkpoint: async (id) => await read(`/performer-page/checkpoint/${id}`),
  checkpoints: async (options) =>
    await read('/performer-page/checkpoints?' + options.toString()),
  project: async (id) => await read('/performer-page/project/' + id),
  projectMyStats: async (id) =>
    await read('/performer-page/project-my-stats/' + id),
  projects: async (options) =>
    await read('/performer-page/projects?' + options.toString()),
  projectSteps: async (id) =>
    await read('/performer-page/project-steps?id=' + id),
  tasks: async (options) =>
    await read('/performer-page/tasks?' + options.toString()),
};

export default performerPage;
